import dayjs from 'dayjs';

/** 目的地 key：配送仓为 `HUB/WHS`（如 LA/SAN），Hub 为 `HUB`（如 EWR） */
export interface DestinationInfo {
    hub: string;
    warehouse: string | null;
    /** 流向，如 LA-SAN / EWR */
    destination: string;
}

export const parseDestinationKey = (key: string): DestinationInfo => {
    const [hub, warehouse] = String(key || '').split('/');
    // warehouse（warehouseCode）本身已是完整的 Hub-Whs 分拣码（如 LAX-NW），不能再拼一次 hub，
    // 否则批次名目的地段会多出 region/hub 段（如 LA-LAX-NW）。与后端 createSortingBatches 口径一致。
    if (warehouse) return { hub, warehouse, destination: warehouse };
    return { hub, warehouse: null, destination: hub };
};

export const destinationKeyOf = (hub: string, warehouse?: string | null): string => (warehouse ? `${hub}/${warehouse}` : hub);

/**
 * 本 Hub 批次名前缀：优先取仓库分拣码首段（如 LA-LADC-A-01 → LA），缺失时取仓库名去掉 hub 后缀（如 LA hub → LA）。
 * 最终批次名由后端生成，此处仅用于前端预览与 mock。
 */
export const resolveHubPrefix = (warehouse?: { sortingCode?: string | null; name?: string | null } | null): string => {
    const code = String(warehouse?.sortingCode || '').trim();
    if (code) return code.split('-')[0].toUpperCase();
    const name = String(warehouse?.name || '').replace(/\s*hub\s*$/i, '').trim();
    return name ? name.split(/\s+/)[0].toUpperCase() : 'HUB';
};

/** 批次名：<Hub前缀>_<YYYYMMDD>_<HHmm>_<目的地> */
export const buildBatchNumber = (hubPrefix: string, time: number | dayjs.Dayjs, destination: string): string => {
    const d = dayjs(time);
    return `${hubPrefix}_${d.format('YYYYMMDD')}_${d.format('HHmm')}_${destination}`;
};

export const previewBatchNumbers = (hubPrefix: string, time: number | dayjs.Dayjs, destinationKeys: string[]): string[] =>
    destinationKeys.map((k) => buildBatchNumber(hubPrefix, time, parseDestinationKey(k).destination));
